/*
================================================================================
                    WPQ TUBESHEET PAGE 1 - BUSINESS LOGIC
================================================================================

PURPOSE: First page of tubesheet WPQ - welder info, base metals, joint details

KEY FEATURES:
• GTAW process default for tubesheet applications
• Joint detail measurements: Hole ID, tube pitch, groove depth/angle
• Image documentation: Tube hole ligament, hole detail, weld joint
• Filler metal specs: SFA, F-Number, A-Number, preplaced metals
• Date sync: WPQ_Date → wld_createdon + 178-day expiry calculation

DATA STRUCTURE:
• Joint details: Actual_Value + Range_Qualified arrays
• Images: S3 storage with 1MB limit (jpeg/png/jpg)
• Base metals: Tube + tubesheet material specs

BUSINESS RULES:
• Joint measurements critical for tube integrity
• Image documentation mandatory
• Range qualified values provide operational flexibility
• Date synchronization across header/detail records

================================================================================
*/

import { Row, Col, Form } from "react-bootstrap";
import { useImperativeHandle, forwardRef, useState, useEffect, useRef } from "react";
import { WPQ_tubePage1, WPQ_Tube_Page1_Process } from "./WPQObjects/WPQ_entity";
import { company_name, WeldedCoupon, Division, PlantLocation } from "../utility/common/TransactionComponents/TransactionEntity";
import { Action, Status } from "../utility/common/constants/CommonConstants"
import { validateForm } from "../utility/common/TransactionComponents/TransactionValidationUtils";
import { handleWPQGeneralSubmit, handleWPQGeneralSubmitTemp } from "../utility/common/TransactionComponents/TransactionSubmitUtils";
import { SearchSelect } from "../utility/forms/inputs/search-select";
import { AddNewGrooveWPQ, getbyrecordno } from "../../Services/wpq_groove-services";
import { getPNOActive } from "../../Services/pcategory-service";
import { getActiveAno } from "../../Services/ano-services";
import { getActiveSfa } from "../../Services/sfa-service";
import { getActiveFno } from "../../Services/fno-services";
import { todayDate, maxDate } from "../utility/common/helpers/TodayDate";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { emptyError, getImage, saveImage, handleCount } from "./WPQObjects/WPQCommonUtils";
import { General_Single_Input_select, SingleInput } from "../utility/forms/inputs/InputsTransaction";
import { getActiveInsp } from "../../Services/inspectionagency-service";
import { getActiveWelder } from "../../Services/Welder-services";
import { calculateWPQExpiryDate } from "./WPQObjects/WPQ_common";
import { AddNewDetailTubesheet, getdetailsById, DeleteWPQ, getRecentLastWeldDate } from "../../Services/wpq_details-service";
import { BaseMetalTableTTS } from "./WPQObjects/BaseMetalTable";
import { WpqJointDetailtable1A } from "./WPQObjects/wpq_JointDetail_table";
import { ImageArray3 } from "../utility/common/TransactionComponents/CommonImages";
import { WPQ_Filler_metals } from "./WPQObjects/WPQ_Filler_metals";
import { DateInput } from "../utility/common/helpers/DateComponent";
import { DotLoader } from "react-spinners";
import PropTypes from "prop-types";
import { isAllowCustomSpecialCharacters, isAllowDashedSpecialCharacters } from "../../functions/validations";
import { showWarning } from "../utility/ui/notifications/Toaster";

/*
 * WPQTubesheetPage1 Component - First page of tubesheet qualification
 * 
 * COMPONENT WORKFLOW:
 * 1. Initialize tubesheet-specific form fields and validation
 * 2. Handle welder selection and auto-populate related data
 * 3. Manage joint detail specifications with actual/qualified values
 * 4. Process image uploads for documentation
 * 5. Handle filler metal specifications and validation
 * 6. Synchronize dates across header and detail records
 * 7. Validate and submit tubesheet page 1 data
 */
const WPQTubesheetPage1 = forwardRef(
  (
    {
      headerObj,
      setheaderObj,
      detailObj,
      setdetailObj,
      normalstyle,
      errorstyle,
      blyestyle,
      isReadonly,
      setReadonly,
      setAction,
      action
    },
    ref
  ) => {
    WPQTubesheetPage1.propTypes = {
      headerObj: PropTypes.array,
      setheaderObj: PropTypes.func,
      setdetailObj: PropTypes.func,
      normalstyle: PropTypes.Text,
      errorstyle: PropTypes.func,
      blyestyle: PropTypes.Text,
      detailObj: PropTypes.array,
      isReadonly: PropTypes.bool,
      error: PropTypes.array,
      setReadonly: PropTypes.func,
    };

    const disableFields = isReadonly;
    let username = sessionStorage.getItem("UserName");
    let folderwpq = "WPQ_Groove";
    const [loading, setLoading] = useState(false);
    const [PNoActive, setPNoActive] = useState([]);
    const [WelderActive, setWelderActive] = useState([]);
    const [ImageView1, setImageView1] = useState(false);
    const [ImageView2, setImageView2] = useState(false);
    const [ImageView3, setImageView3] = useState(false);

    const [InspecAgencyActive, setInspecAgencyActive] = useState([]);
    const [IsEdited, setIsEdited] = useState(false);

    const [SfaActive, setSfaActive] = useState([]);
    const [FnoActive, setFnoActive] = useState([]);
    const [AnoActive, setAnoActive] = useState([]);
    const [chemicalAnaError, setChemicalAnaError] = useState([]);

    const fileInputRef = useRef(null);
    const FilemaxSize = 1 * 1024 * 1024;
    const [classError, setClassError] = useState([]);
    const [profile, setProfile] = useState("");
    const [profile1, setProfile1] = useState("");
    const [profile2, setProfile2] = useState("");

    const [previewUrl1, setPreviewUrl1] = useState();
    const [previewUrl2, setPreviewUrl2] = useState();
    const [previewUrl3, setPreviewUrl3] = useState();

    const [error, setError] = useState({
      WPQ_WelderId: {},
      WPQ_WelderName: {},
      WPQ_Date: {},
      WPQ_RecordNo: {},
      WPQ_Wps_RecordNo: {},
      WPQ_ReviNo: {},
      WPQ_Inspection: {},
      WPQ_DOB: {},
      WPQ_Qualificationcode: {},
      WPQ_Last_UpdatedDate: {},
      WPQ_Last_UpdatedBy: {},
      WPQ_Welded_on_coupon: {},
      WPQ_Division: {},
      WPQ_PlantLocation: {},
      WPQ_specialNote: {},
      WPQ_Status: {},

      WPQ_BM_BM_ProductForm: {},
      WPQ_BM_BM_Spec: {},
      WPQ_BM_BM_Pno: {},
      WPQ_BM_BM_Gno: {},
      WPQ_BM_BM_Thk: {},
      WPQ_BM_BM_Dia: {},

      WPQ_BM_WTBM_ProductForm: {},
      WPQ_BM_WTBM_Spec: {},
      WPQ_BM_WTBM_Pno: {},
      WPQ_BM_WTBM_Gno: {},
      WPQ_BM_WTBM_Thk: {},
      WPQ_BM_WTBM_Dia: {},
      WPQ_BM_RangeQualified_Thk: {},
      WPQ_BM_RangeQualified_Dia: {},

      WPQ_VAR_TypeofJoint_actualValue: {},
      WPQ_VAR_TypeofJoint_RangeQualified: {},
      WPQ_VAR_BaseM_actualValue: {},
      WPQ_VAR_BaseM_RangeQualified: {},

      WPQ_BMT_BaseM_ActualV_Groove: {},
      WPQ_BMT_BaseM_ActualV_Fillet: {},
      WPQ_BMT_BaseM_ActualV_Overlay: {},

      WPQ_BMT_BaseM_RangeQ_Groove: {},
      WPQ_BMT_BaseM_RangeQ_Fillet: {},
      WPQ_BMT_BaseM_RangeQ_Overlay: {},

      WPQ_BMT_WeldedTo_ActualV_Groove: {},
      WPQ_BMT_WeldedTo_ActualV_Fillet: {},
      WPQ_BMT_WeldedTo_ActualV_Overlay: {},
      WPQ_BMT_WeldedTo_RangeQ_Groove: {},
      WPQ_BMT_WeldedTo_RangeQ_Fillet: {},
      WPQ_BMT_WeldedTo_RangeQ_Overlay: {},
      WPQ_WP_Process_Process: {},
      WPQ_WP_Process_Type: {},
      WPQ_WP_Type_Process: {},
      WPQ_WP_Type_Type: {},
      WPSH_Project_No: {},
      WPSH_WPS_No: {},
      WPSH_WPS_Revi_No: {},
      WPS_QualifiedTo: {},
      WPSH_SupportingPQR: {},
      WPSH_WPS_Date: {},
      WPSH_RefDoc: {},
      WPSH_Scope: {},
      WPSH_JointDesc: {},
      WPSH_BM_Type_Type: {},
      WPSH_BM_WeldingTo_Type: {},
      WPSH_BM_Type_GNo: {},
      WPSH_BM_Type_PNo: {},
      WPSH_BM_WeldingTo_PNo: {},
      WPSH_BM_WeldingTo_GNo: {},
      WPSH_BM_Backing_Backing: {},
      WPSH_BM_Backing_GNo: {},
      WPSH_BM_Backing_PNo: {},
      WPSH_BM_Retainer: {},
      WPSH_WPS_WeldLayer: {},
      WPSH_BM_Backing_Material: {},
      WPSH_ConsuInsert_SFA: {},
      WPSH_ConsuInsert_Classification: {},
      WPSH_ConsuInsert_FNo: {},
      WPSH_ConsuInsert_ANo: {},
      WPSH_ConsuInsert_ChemicalAnalysis_TradeName: {},
      WPSH_Flux_SFA: {},
      WPSH_Flux_Classification: {},
      WPSH_Flux_FNo: {},
      WPSH_Flux_ANo: {},
      WPSH_Flux_ChemicalAnalysis_TradeName: {},
      WPSH_SupFiller_SFA: {},
      WPSH_SupFiller_Classification: {},
      WPSH_SupFiller_FNo: {},
      WPSH_SupFiller_ANo: {},
      WPSH_SupFiller_ChemicalAnalysis_TradeName: {},
      WPSH_BM_Notes: {},
      WPSH_TRQ_GroovewithoutImpact_Min: {},
      WPSH_TRQ_GroovewithoutImpact_Max: {},
      WPSH_TRQ_GroovewithImpact_Min: {},
      WPSH_TRQ_GroovewithImpact_Max: {},
      WPSH_TRQ_FilletwithoutImpact_Min: {},
      WPSH_TRQ_FilletwithoutImpact_Max: {},
      WPSH_TRQ_FilletwithImpact_Min: {},
      WPSH_TRQ_FilletwithImpact_Max: {},
      WPSH_FM_FluxType: {},
      WPSH_FM_AlloyFlux: {},
      WPSH_FM_AlloyElement: {},
      WPSH_FM_Add_Del_Filler: {},
      WPSH_FM_Add_Del_Flux: {},
      WPSH_FM_Add_Del_orchange: {},
      WPSH_FM_FluxItemBatch: {},
      WPSH_FM_FluxFromRecrush: {},
      WPSH_FM_FluxItemCode: {},
      WPSH_FM_FilerMetal: {},
      WPSD_FM_Classification: {},
      WPSH_BM_Type_HT_Con: {},
      WPSH_BM_WeldingTo_HT_Con: {},
      WPSD_FM_ChemicalAnalysis_TradeName: {},
      WPSD_FM_TRQ_Min: {},
      WPSD_FM_TRQ_Max: {},
      WPSH_ConsuInsert: {},
      WPSD_FM_Make: {},
      WPSH_Flux: [],
      WPSH_SupFiller: [],
      WPSH_MinOvlFinThick: {},

      WPQ_Process: {},
      WPSH_TRQ_BaseMetalCRO_Min: {},
      WPSH_TRQ_BaseMetalCRO_Max: {},
      WPSH_TRQ_BaseMetalHRO_Min: {},
      WPSH_TRQ_BaseMetalHRO_Max: {},

      WPSH_BM_BaseMetal1_ProductForm: "",
      WPSH_BM_BaseMetal1_Spec: "",
      WPSH_BM_BaseMetal1_PNo: "",
      WPSH_BM_BaseMetal1_GNo: "",
      WPSH_BM_BaseMetal1_Thick: "",
      WPSH_BM_BaseMetal1_Diam: "",
      WPSH_BM_WeldBaseMetal2_ProductForm: "",
      WPSH_BM_WeldBaseMetal2_Spec: "",
      WPSH_BM_WeldBaseMetal2_PNo: "",
      WPSH_BM_WeldBaseMetal2_GNo: "",
      WPSH_BM_WeldBaseMetal2_Thick: "",
      WPSH_BM_WeldBaseMetal2_Diam: "",
      WPSH_JD_JointType: {},
      WPSH_JD_HoleId: {},
      WPSH_JD_TubePitch: {},
      WPSH_JD_GrooveDepth: {},
      WPSH_JD_TubeProj: {},
      WPSH_JD_WidthLigament: {},
      WPSH_JD_Pattern: {},
      WPSH_JD_GrooveAngle: {},
      WPSH_JD_GrooveType: {},
      WPQ_FM_PreFillerMetal: {},
      WPQ_FM_WithFillerMetal: {},
      WPQ_FM_FillerProduct: {},
      WPQ_FM_Inserts: {},
      WPQ_FM_FillerOthers: {},
      WPSD_FM_SFA: {},

      WPSD_FM_FNo: {},
      WPSD_FM_Ano: {},

      WPQ_Joint_Type: [{ Actual_Value: [""] }, { Range_Qualified: [""] }],
      WPQ_Hole_Id: [{ Actual_Value: [""] }, { Range_Qualified: [""] }],
      WPQ_Tube_Pitch: [{ Actual_Value: [""] }, { Range_Qualified: [""] }],
      WPQ_Groove_Depth: [{ Actual_Value: [""] }, { Range_Qualified: [""] }],

      WPQ_Tube_Projection: [{ Actual_Value: [""] }, { Range_Qualified: [""] }],
      WPQ_Width_Ligament: [{ Actual_Value: [""] }, { Range_Qualified: [""] }],
      WPQ_Pattern: [{ Actual_Value: [""] }, { Range_Qualified: [""] }],
      WPQ_Groove_Angle: [{ Actual_Value: [""] }, { Range_Qualified: [""] }],

      wld_pdf_image: {},
    });

    const handleChange = (e) => {
      setIsEdited(true);
      const { name, value } = e.target;
      setheaderObj((prevState) => ({
        ...prevState,
        [name]: value,
      }));

      // Sync dates when Welding Date changes
      if (e.target.name === "WPQ_Date") {
        syncDatesWithWeldingDate(e.target.value);
      }
    };

    const handleActualValueChange = (key, id, valueIndex, newValue) => {
      setIsEdited(true);
      const updatedProcessObj = { ...headerObj };
      updatedProcessObj[key][id].Actual_Value[valueIndex] = newValue;
      setheaderObj(updatedProcessObj);
    };

    const handleRangeQualifiedChange = (key, id, valueIndex, newValue) => {
      setIsEdited(true);
      const updatedProcessObj = { ...headerObj };
      updatedProcessObj[key][id].Range_Qualified[valueIndex] = newValue;
      setheaderObj(updatedProcessObj);
    };

    // Sync detail dates when WPQ_Date changes
    useEffect(() => {
      if (headerObj?.WPQ_Date && detailObj) {
        syncDatesWithWeldingDate(headerObj.WPQ_Date);
      }
    }, [headerObj?.WPQ_Date]);

    // DATE SYNC: Tubesheet welding date → detail records + 178-day expiry with smart recent date logic
    const syncDatesWithWeldingDate = async (weldingDate) => {
      if (!weldingDate || !detailObj) return;
      console.log("🔄 SYNC: Starting date synchronization - Welding Date:", weldingDate);

      try {
        // Convert YYYY-MM-DD to DD-MM-YYYY for details
        const [year, month, day] = weldingDate.split("-");
        if (!year || !month || !day) return;

        const detailDateFormat = `${day.padStart(2, '0')}-${month.padStart(2, '0')}-${year}`;
        const isToday = new Date(parseInt(year), parseInt(month) - 1, parseInt(day)).setHours(0,0,0,0) === new Date().setHours(0,0,0,0);
        
        console.log("📅 SYNC: Is today's date?", isToday);

        if (isToday) {
          // Use today's date
          setdetailObj(prevDetail => ({
            ...prevDetail,
            wld_createdon: detailDateFormat,
            WPQ_Welder_ExpiresOn: calculateWPQExpiryDate(detailDateFormat),
            wld_process_status: prevDetail.wld_process_status || "Active"
          }));
          return;
        }

        // For non-today dates, fetch recent date and compare
        try {
          // For tubesheet, use GTAW process category
          const processCategory = `GTAW#${detailObj?.WPQD_WP_Type}`;
          let recentDate = null;
          if (detailObj?.WPQD_WP_Type) {
            recentDate = await getRecentLastWeldDate({
              WPQ_WelderId: headerObj.WPQ_WelderId,
              WPQ_Process_Category: processCategory,
              WPSH_Status: "Approved"
            });
          }
          

          let finalLastWeldDate = detailDateFormat;
          
          if (recentDate) {
            // Compare dates and use the greater one
            const selectedDateObj = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
            const [recentDay, recentMonth, recentYear] = recentDate.split("-");
            const recentDateObj = new Date(parseInt(recentYear), parseInt(recentMonth) - 1, parseInt(recentDay));
            
            // Use the greater date
            finalLastWeldDate = selectedDateObj >= recentDateObj ? detailDateFormat : recentDate;
            console.log(`📊 COMPARE: Tubesheet - Selected: ${detailDateFormat}, Recent: ${recentDate}, Using: ${finalLastWeldDate}`);
          }

          setdetailObj(prevDetail => ({
            ...prevDetail,
            wld_createdon: finalLastWeldDate,
            WPQ_Welder_ExpiresOn: calculateWPQExpiryDate(finalLastWeldDate),
            wld_process_status: prevDetail.wld_process_status || "Active"
          }));

        } catch (error) {
          console.warn("⚠️ Could not fetch recent date for tubesheet, using selected date");
          setdetailObj(prevDetail => ({
            ...prevDetail,
            wld_createdon: detailDateFormat,
            WPQ_Welder_ExpiresOn: calculateWPQExpiryDate(detailDateFormat),
            wld_process_status: prevDetail.wld_process_status || "Active"
          }));
        }

      } catch (error) {
        console.error("❌ SYNC: Error syncing dates:", error);
      }
    };

    const validate = async () => {
      let temperror = emptyError(error, setError, false);
      const validationResult = validateForm({
        headerObj,
        detailObj,
        requiredFields: WPQ_tubePage1,
        detailConfig: WPQ_Tube_Page1_Process,
        currentErrors: error,
      });

      let isError = validationResult.isError;
      let finalErrors = validationResult.errors;

      if ((action === Action.ActionCopy || action === Action.ActionAdd) && !isError) {
        if (await checkDuplicate(headerObj?.wld_WPSType, headerObj?.WPQ_WelderId, headerObj?.WPQ_RecordNo)) {
          isError = true;
          finalErrors.WPQ_WelderId = {
            status: true,
            message: "Project Number & WPQ Number already exists",
          };
        }
      }
      setError((prevState) => ({
        ...prevState,
        ...finalErrors,
      }));
      return { isError, temperror };
    };

    const checkDuplicate = async (type, proj, revno) => {
      let result = await getbyrecordno(type, proj, revno);
      return result[0] !== undefined;
    };

    const validateTemp = async () => {
      let isError = false;
      let temperror = emptyError(error, setError, isError);
      if (headerObj?.WPQ_WelderId.trim() === "") {
        headerObj.WPQ_WelderId = "";
        isError = true;
        error.WPQ_WelderId = {
          status: true,
          message: "This field is required",
        };
      }
      if (headerObj?.WPQ_RecordNo.trim() === "") {
        headerObj.WPQ_RecordNo = "";
        isError = true;
        error.WPQ_RecordNo = {
          status: true,
          message: "This field is required",
        };
      }

      if (!(action === Action.ActionEdit && isError)) {
        if (
          await checkDuplicate(headerObj?.WPQ_WelderId, headerObj?.WPQ_RecordNo)
        ) {
          isError = true;
          error.WPQ_WelderId.status = true;
          error.WPQ_WelderId.message =
            "Project Number & WPQ Number already exists";
        } else {
          error.WPQ_WelderId.status = false;
          error.WPQ_WelderId.message = "";
        }
      }
      setError((prevState) => ({
        ...prevState,
        ...error,
      }));

      return { isError, temperror };
    };

    const handleChangedetailsarray = (e, i) => {
      setIsEdited(true);
      const { name, value } = e.target;
      setdetailObj((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    };

    // SUBMISSION: Creates header + detail records, processes S3 images
    const handleAdd = async () => {
      let result = false;
      headerObj.WPQ_CompanyName = company_name[0]?.value;
      // if (headerObj?.WPQ_Status === "Active") {
      //   headerObj.WPQ_Status = "Active";
      // } else {
      //   headerObj.WPQ_Status = "Inactive";
      // }

      headerObj.WPQ_Last_UpdatedBy = username;

      if (
        headerObj?.WPSH_Status === Status.StatusApproved ||
        headerObj?.WPSH_Status === Status.StatusRejected
      ) {
        headerObj.WPSH_Status = Status.StatusPending;
        if (headerObj?.WPSH_Status === Status.StatusApproved) handleCount();
      }

      if (action === Action.ActionCopy) {
        headerObj.WPSH_Status = Status.StatusTempSaved;
        headerObj.WPSH_PreparedBy = sessionStorage.getItem("User");
      }

      let WPSH_WPQ_Process = "";
      let WPSH_WPQ_Type = "";

      detailObj.WPQ_WelderId = headerObj?.WPQ_WelderId;
      detailObj.WPQ_WelderName = headerObj?.WPQ_WelderName;
      detailObj.WPQ_RecordNo = headerObj?.WPQ_RecordNo;

      detailObj.PK = headerObj?.WPQ_WelderId + "#" + headerObj?.WPQ_RecordNo;

      WPSH_WPQ_Process += detailObj.WPQ_Process;
      WPSH_WPQ_Type += detailObj.WPSD_FM_SFA;

      headerObj.WPSH_WPQ_Process = WPSH_WPQ_Process;
      headerObj.WPSH_WPQ_Type = detailObj.WPSD_FM_SFA;

      detailObj.WPSH_WPQ_Process = headerObj?.WPSH_WPQ_Process;

      detailObj.wld_WPSType = headerObj?.wld_WPSType;

      detailObj.SK = headerObj?.WPSH_WPQ_Process + "#" + headerObj?.WPSH_WPQ_Type;

      headerObj.WQC_Last_Weld_Date = [{ Process: detailObj.SK, LastWeldDate: detailObj.wld_createdon }];
      let addresult = await AddNewGrooveWPQ(headerObj);
      if (addresult !== undefined) {
        try {
          if (profile !== "") {
            saveImage(
              headerObj?.Pdf_images[0]?.tube_Hole_ligament[0],
              folderwpq,
              setPreviewUrl1,
              setImageView1,
              profile
            );
          }
          if (profile1 !== "") {
            saveImage(
              headerObj?.Pdf_images[1].tube_Hole[0],
              folderwpq,
              setPreviewUrl2,
              setImageView2,
              profile1
            );
          }
          if (profile2 !== "") {
            await saveImage(
              headerObj?.Pdf_images[2].tube_Weld_Joint[0],
              folderwpq,
              setPreviewUrl3,
              setImageView3,
              profile2
            );
          }
        } catch (error) {
          console.log("Error", error);
        }

        let oldProcess = await getdetailsById(headerObj.WPQ_WelderId, headerObj.WPQ_RecordNo);
        //delete old process
        for (const item of oldProcess) {
          let NotFoundprocess = detailObj.PK.toString() == item.PK.toString() && detailObj.SK.toString() == item.SK.toString();
          if (!NotFoundprocess) {
            await DeleteWPQ(item.PK, item.SK);
          }
        }

        setAction(Action.ActionEdit);
        result = true;

        await AddNewDetailTubesheet(detailObj)
          .catch((err) => {
            console.log("Error", err);
          })
          .then((r) => {
            setAction(Action.ActionEdit);
            result = true;
          });
      } else {
        showWarning(process.env.REACT_APP_SPECIAL_CHARACTER_MSG);
      }

      return result;
    };

    const fetchPNo = async () => {
      const result = await getPNOActive();

      setPNoActive(result);
    };

    const fetchSfa = async () => {
      const result = await getActiveSfa();
      setSfaActive(result);
    };
    const fetchAno = async () => {
      const result = await getActiveAno();
      setAnoActive(result);
    };
    const fetchFno = async () => {
      const result = await getActiveFno();
      setFnoActive(result);
    };

    const fetchWelder = async () => {
      const result = await getActiveWelder();
      // Check if wld_salarycode is empty, if so, use wld_code as wld_salarycode
      const modifiedResult = result.map((welder) => ({
        ...welder,
        wld_salarycode: welder.wld_salarycode || welder.wld_code,
      }));
      setWelderActive(modifiedResult);
    };

    const fetchInspecAgency = async () => {
      const result = await getActiveInsp();
      setInspecAgencyActive(result);
    };

    useEffect(() => {
      fetchPNo();
      fetchInspecAgency();
      fetchWelder();
      fetchSfa();
      fetchAno();
      fetchFno();
    }, []);




    useEffect(() => {
      if ((action === Action.ActionEdit || action === Action.ActionCopy) && headerObj?.Pdf_images?.[0]?.tube_Hole_ligament?.[0] && headerObj.Pdf_images[0].tube_Hole_ligament[0] !== "") {
        console.log("Loading image 1:", headerObj.Pdf_images[0].tube_Hole_ligament[0]);
        getImage(
          headerObj.Pdf_images[0].tube_Hole_ligament[0],
          folderwpq,
          setPreviewUrl1
        );
      }

      if ((action === Action.ActionEdit || action === Action.ActionCopy) && headerObj?.Pdf_images?.[1]?.tube_Hole?.[0] && headerObj.Pdf_images[1].tube_Hole[0] !== "") {
        console.log("Loading image 2:", headerObj.Pdf_images[1].tube_Hole[0]);
        getImage(
          headerObj.Pdf_images[1].tube_Hole[0],
          folderwpq,
          setPreviewUrl2
        );
      }

      if (
        (action === Action.ActionEdit || action === Action.ActionCopy) &&
        headerObj?.Pdf_images?.[2]?.tube_Weld_Joint?.[0] && headerObj.Pdf_images[2].tube_Weld_Joint[0] !== ""
      ){
        console.log("Loading image 3:", headerObj.Pdf_images[2].tube_Weld_Joint[0]);
        getImage(
          headerObj.Pdf_images[2].tube_Weld_Joint[0],
          folderwpq,
          setPreviewUrl3
        );
      }
    }, [headerObj, action]);

    useEffect(() => {
      if (ImageView1 === true && headerObj?.Pdf_images?.[0]?.tube_Hole_ligament?.[0] && headerObj.Pdf_images[0].tube_Hole_ligament[0] !== "") {
        getImage(
          headerObj.Pdf_images[0].tube_Hole_ligament[0],
          folderwpq,
          setPreviewUrl1
        );
      }
    }, [ImageView1]);

    useEffect(() => {
      if (ImageView2 === true && headerObj?.Pdf_images?.[1]?.tube_Hole?.[0] && headerObj.Pdf_images[1].tube_Hole[0] !== "") {
        getImage(
          headerObj.Pdf_images[1].tube_Hole[0],
          folderwpq,
          setPreviewUrl2
        );
      }
    }, [ImageView2]);

    useEffect(() => {
      if (ImageView3 === true && headerObj?.Pdf_images?.[2]?.tube_Weld_Joint?.[0] && headerObj.Pdf_images[2].tube_Weld_Joint[0] !== "") {
        getImage(
          headerObj.Pdf_images[2].tube_Weld_Joint[0],
          folderwpq,
          setPreviewUrl3
        );
      }
    }, [ImageView3]);

    const handleSubmit = () => handleWPQGeneralSubmit(validate, handleAdd, setLoading, setIsEdited, Status.StatusPending);
    const handleSubmitTemp = () => handleWPQGeneralSubmitTemp(IsEdited, validateTemp, handleAdd, setLoading, setIsEdited, headerObj?.WPQH_Status || Status.StatusTempSaved);


    useImperativeHandle(ref, () => ({
      funcOnNext: async () => {
        let res = false;
        res = await handleSubmit();
        return res;
      },
      funcOnNextTemp: async () => {
        let res = false;
        res = await handleSubmitTemp();
        return res;
      },
    }));

    const handleFile1 = (file, index, e) => {
      const maxSize = FilemaxSize;
      if (file.size > maxSize) {
        showWarning("File size exceeds the allowed limit. Add File Less Than 1 Mb");
        file = null;
        return;
      }
      let uploadextension = file.name.split(".");
      if (
        uploadextension[1] !== "jpeg" &&
        uploadextension[1] !== "png" &&
        uploadextension[1] !== "jpg"
      ) {
        showWarning("Please Upload Jpeg, png or jpg images");
        file = null;
        return;
      }

      // Initialize Pdf_images structure if it doesn't exist
      if (!headerObj.Pdf_images) {
        headerObj.Pdf_images = [
          { tube_Hole_ligament: [""] },
          { tube_Hole: [""] },
          { tube_Weld_Joint: [""] }
        ];
      }

      if (index == 0) {
        setProfile(file);
        setPreviewUrl1(URL.createObjectURL(file));
        headerObj.Pdf_images[0].tube_Hole_ligament[0] = file.name;
      } else if (index == 1) {
        setProfile1(file);
        setPreviewUrl2(URL.createObjectURL(file));
        headerObj.Pdf_images[1].tube_Hole[0] = file.name;
      } else if (index == 2) {
        setProfile2(file);
        setPreviewUrl3(URL.createObjectURL(file));
        headerObj.Pdf_images[2].tube_Weld_Joint[0] = file.name;
      }
      setIsEdited(true);
    };

    return (
      <Row className="font">
        {loading && (
          <div className="loader-overlay">
            <DotLoader size={80} className="pageloader" />
          </div>
        )}
        <Row style={{ padding: "20px 60px" }} className="WPQ-Page-row-padding">
          <Row className="mb-2">
            <Col md={3}>
              <Form.Group className="pro-input-select">
                <div className="search-select">
                  <SearchSelect
                    id="WPQ_WelderId"
                    name="WPQ_WelderId"
                    className={error.WPQ_WelderId.status ? "err-input" : ""}
                    stylegreen={
                      error.WPQ_WelderId.status ? errorstyle : normalstyle
                    }
                    data={WelderActive}
                    valueField={"wld_salarycode"}
                    disabled={action === Action.ActionEdit}
                    value={headerObj?.WPQ_WelderId || ""}
                    labelField1={"wld_salarycode"}
                    labelField2={"wld_name"}
                    placeholder=""
                    onChange={(List) => {
                      setheaderObj((prev) => ({
                        ...prev,
                        WPQ_WelderId: List.value,
                      }));
                      setError((prevState) => ({
                        ...prevState,
                        WPQ_WelderId: {},
                      }));
                      let a = WelderActive.filter((b) => {
                        return b.wld_salarycode == List.value;
                      });
                      setheaderObj((prev) => ({
                        ...prev,
                        WPQ_WelderId: a[0].wld_salarycode,
                        WPQ_WelderName: a[0].wld_name,
                      }));
                      if (action === Action.ActionCopy) {
                        setReadonly(false);
                      }
                      setIsEdited(true)
                    }}
                  ></SearchSelect>
                </div>
                <Form.Label>Welder Id</Form.Label>
                <div className="required-text-select">
                  {error.WPQ_WelderId.status && (
                    <Form.Text className="text-danger">
                      {error.WPQ_WelderId.message}
                    </Form.Text>
                  )}
                </div>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <div className="T-input w-100">
                  <input
                    type="text"
                    id="WPQ_WelderName"
                    name="WPQ_WelderName"
                    readOnly
                    placeholder=" "
                    disabled={action === Action.ActionEdit}
                    maxLength={20}
                    value={headerObj?.WPQ_WelderName}
                    onChange={(e) => {
                      handleChange(e);
                      if (action === Action.ActionCopy) {
                        setReadonly(false);
                      }
                    }}
                  />
                  <Form.Label htmlFor="WPQ_WelderName">Welder Name</Form.Label>
                </div>
              </Form.Group>
            </Col>
            <Col md={3}>
              <div className="groove_date">
                <div className="T-input w-100">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={["DatePicker"]}>
                      <DatePicker
                        label="Welding Date"
                        className="groove_datecolor"
                        format="DD-MM-YYYY"
                        name="WPQ_Date"
                        sx={{ fontSize: "6px", fontFamily: "GE-BodyCopy" }}
                        // disabled={disableFields}
                        disabled={action === Action.ActionEdit && headerObj.WPSH_Status === Status.StatusApproved}
                        readOnly={isReadonly}
                        value={
                          headerObj?.WPQ_Date
                            ? dayjs(headerObj?.WPQ_Date)
                            : dayjs(todayDate)
                        }
                        maxDate={dayjs(maxDate)}
                        onChange={(e) => {
                          let date = dayjs(e).format("YYYY-MM-DD");
                          setheaderObj((prev) => ({
                            ...prev,
                            WPQ_Date: date,
                          }));
                          setError((prevState) => ({
                            ...prevState,
                            WPQ_Date: {
                              status: false,
                              message: "",
                            },
                          }));
                        }}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                </div>
              </div>
              <div className="required-text-select mt-2">
                {error.WPQ_Date.status && (
                  <Form.Text className="text-danger">
                    {error.WPQ_Date.message}
                  </Form.Text>
                )}
              </div>
            </Col>
            <Col md={3}>
              <Form.Group>
                <SingleInput
                  name="WPQ_RecordNo"
                  type="text"
                  maxLength={20}
                  status={error.WPQ_RecordNo.status}
                  disabled={action === Action.ActionEdit}
                  value={headerObj?.WPQ_RecordNo}
                  onChange={(e) => {
                    handleChange(e);
                    setIsEdited(true)
                    if (action === Action.ActionCopy) {
                      setReadonly(false);
                    }
                  }}
                  setError={setError}
                  error={error}
                  readOnly={isReadonly}
                  label="WPQ Record Number"
                  message={error.WPQ_RecordNo.message}
                  allowlistfunction={isAllowCustomSpecialCharacters}
                  allowcharacters="-"
                  customMessage="Special Characters # & % + $ ' < > = ; not allowed"
                ></SingleInput>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <SingleInput
                  name="WPQ_Wps_RecordNo"
                  type="text"
                  maxLength={15}
                  readOnly={isReadonly}
                  status={error.WPQ_Wps_RecordNo.status}
                  value={headerObj?.WPQ_Wps_RecordNo}
                  onChange={handleChange}
                  setError={setError}
                  error={error}
                  label="WPS Record Number"
                  message={error.WPQ_Wps_RecordNo.message}
                  disabled={disableFields}
                  allowlistfunction={isAllowCustomSpecialCharacters}
                  allowcharacters="-"
                  customMessage="Special Characters # & % + $ ' < > = ; not allowed"
                ></SingleInput>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <SingleInput
                  name="WPQ_ReviNo"
                  type="text"
                  maxLength={10}
                  status={error.WPQ_ReviNo.status}
                  readOnly={isReadonly}
                  disabled={disableFields}
                  value={headerObj?.WPQ_ReviNo}
                  onChange={handleChange}
                  setError={setError}
                  error={error}
                  label="Rev.No"
                  message={error.WPQ_ReviNo.message}
                ></SingleInput>
              </Form.Group>
            </Col>
            <Col md={3} className="mb-1">
              <Form.Group className="pro-input-select">
                <div className="search-select">
                  <SearchSelect
                    required
                    data={InspecAgencyActive}
                    stylegreen={
                      error.WPQ_Inspection.status ? errorstyle : normalstyle
                    }
                    disabled={disableFields}
                    valueField={"wld_code"}
                    value={headerObj?.WPQ_Inspection}
                    labelField={"wld_code"}
                    placeholder=""
                    className={error.WPQ_Inspection.status ? "err-input" : ""}
                    onChange={(pnoList) => {
                      setheaderObj((prev) => ({
                        ...prev,
                        WPQ_Inspection: pnoList.value,
                      }));
                      setError((prevState) => ({
                        ...prevState,
                        WPQ_Inspection: {},
                      }));
                    }}
                  ></SearchSelect>
                </div>
                <Form.Label>Inspection Agency</Form.Label>
              </Form.Group>
              <div className="required-text-select">
                {error.WPQ_Inspection.status && (
                  <Form.Text className="text-danger">
                    {error.WPQ_Inspection.message}
                  </Form.Text>
                )}
              </div>
            </Col>
            <Col md={3}>
              <div className="groove_date">
                <div className="T-input w-100">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={["DatePicker"]}>
                      <DatePicker
                        label="Date Of Birth"
                        className="groove_datecolor"
                        format="DD-MM-YYYY"
                        name="WPQ_DOB"
                        readOnly={isReadonly}
                        disabled={disableFields}
                        sx={{
                          fontSize: "6px",
                          fontFamily: "GE-BodyCopy,sans-serif",
                        }}
                        value={
                          headerObj?.WPQ_DOB
                            ? dayjs(headerObj?.WPQ_DOB)
                            : dayjs(todayDate)
                        }
                        maxDate={dayjs(maxDate)}
                        onChange={(e) => {
                          let date = dayjs(e).format("YYYY-MM-DD");
                          setheaderObj((prev) => ({
                            ...prev,
                            WPQ_DOB: date,
                          }));
                          setError((prevState) => ({
                            ...prevState,
                            WPQ_DOB: {
                              status: false,
                              message: "",
                            },
                          }));
                        }}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                </div>
              </div>
              <div className="required-text-select mt-2">
                {error.WPQ_DOB.status && (
                  <Form.Text className="text-danger">
                    {error.WPQ_DOB.message}
                  </Form.Text>
                )}
              </div>
            </Col>
            <Col md={3}>
              <Form.Group>
                <SingleInput
                  name="WPQ_Qualificationcode"
                  type="text"
                  maxLength={20}
                  readOnly={isReadonly}
                  disabled={disableFields}
                  status={error.WPQ_Qualificationcode.status}
                  value={headerObj?.WPQ_Qualificationcode}
                  onChange={handleChange}
                  setError={setError}
                  error={error}
                  label="Qualification Code"
                  message={error.WPQ_Qualificationcode.message}
                ></SingleInput>
              </Form.Group>
            </Col>
            <Col md={3}>
              <DateInput
                divClass="T-input w-100"
                label="Last Updated Date"
                className="groove_datecolor"
                name="WPQ_Last_UpdatedDate"
                todayDate={todayDate}
                maxDate={maxDate}
                disabled={disableFields}
                readOnly={isReadonly}
                obj={headerObj}
                setobj={setheaderObj}
                setError={setError}
                status={error.WPQ_Last_UpdatedDate.status}
                message={error.WPQ_Last_UpdatedDate.message}
              />
            </Col>
            <Col md={3}>
              <Form.Group>
                <SingleInput
                  name="WPQ_Last_UpdatedBy"
                  type="text"
                  readOnly={isReadonly}
                  disabled={disableFields}
                  value={
                    action === Action.ActionEdit
                      ? headerObj?.WPQ_Last_UpdatedBy
                      : username
                  }
                  onChange={handleChange}
                  setError={setError}
                  error={error}
                  label="Last Updated By"
                ></SingleInput>
              </Form.Group>
            </Col>
            <Col md={3} className="mb-1">
              <Form.Group className="pro-input-select">
                <div className="search-select">
                  <SearchSelect
                    required
                    data={WeldedCoupon}
                    stylegreen={
                      error.WPQ_Welded_on_coupon.status
                        ? errorstyle
                        : normalstyle
                    }
                    readOnly={isReadonly}
                    disabled={disableFields}
                    valueField={"WPQ_Welded_on_coupon"}
                    value={headerObj?.WPQ_Welded_on_coupon}
                    labelField={"WPQ_Welded_on_coupon"}
                    placeholder=""
                    className={
                      error.WPQ_Welded_on_coupon.status ? "err-input" : ""
                    }
                    onChange={(pnoList) => {
                      setheaderObj((prev) => ({
                        ...prev,
                        WPQ_Welded_on_coupon: pnoList.value,
                      }));
                      setError((prevState) => ({
                        ...prevState,
                        WPQ_Welded_on_coupon: {},
                      }));
                    }}
                  ></SearchSelect>
                </div>
                <Form.Label>Welded On Coupon</Form.Label>
              </Form.Group>
              <div className="required-text-select">
                {error.WPQ_Welded_on_coupon.status && (
                  <Form.Text className="text-danger">
                    {error.WPQ_Welded_on_coupon.message}
                  </Form.Text>
                )}
              </div>
            </Col>
            <Col md={3}>
              <Form.Group>
                <SingleInput
                  readOnly
                  disabled={disableFields}
                  name="WPQ_CompanyName"
                  type="text"
                  value={company_name[0]?.value}
                  label="Company name"
                  setError={setError}
                  error={error}
                ></SingleInput>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <General_Single_Input_select
                  name="WPQ_Division"
                  type="text"
                  maxLength={20}
                  readOnly={isReadonly}
                  disabled={disableFields}
                  status={error.WPQ_Division.status}
                  value={headerObj?.WPQ_Division}
                  handleSelectChange={handleChange}
                  label="Division"
                  message={error.WPQ_Division.message}
                  array={Division}
                ></General_Single_Input_select>
              </Form.Group>
            </Col>
            {/* <Col md={3}>
              <Form.Group className="form-switch-input">
                <Form.Label className="fieldLabel mb-0">Status</Form.Label>
                <Form.Switch
                  disabled={disableFields}
                  className={headerObj?.WPQ_Status ? "semiBoldToggleButton activeToggleLabel" : "semiBoldToggleButton inactiveToggleLabel"}
                  name="WPQ_Status"
                  checked={headerObj?.WPQ_Status}
                  onChange={(e) => {
                    setheaderObj((prevState) => ({
                      ...prevState,
                      WPQ_Status: e.target.checked,
                    }));
                    setIsEdited(true);
                  }}
                />
                <span className={headerObj?.WPQ_Status ? "fieldLabel activeToggleLabel" : "fieldLabel inactiveToggleLabel"}>
                  {headerObj?.WPQ_Status ? "Active" : "Inactive"}
                </span>
              </Form.Group>
            </Col> */}
          </Row>
          <Row className="row-margin mt-1">
            <Col md={3}>
              <Form.Group>
                <General_Single_Input_select
                  name="WPQ_PlantLocation"
                  type="text"
                  maxLength={20}
                  readOnly={isReadonly}
                  disabled={disableFields}
                  status={error.WPQ_PlantLocation.status}
                  value={headerObj?.WPQ_PlantLocation}
                  handleSelectChange={handleChange}
                  label="Plant Location"
                  message={error.WPQ_PlantLocation.message}
                  array={PlantLocation}
                ></General_Single_Input_select>
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group>
                <SingleInput
                  disabled={disableFields}
                  name="WPQ_specialNote"
                  type="text"
                  maxLength={20}
                  readOnly={isReadonly}
                  status={error.WPQ_specialNote.status}
                  value={headerObj?.WPQ_specialNote}
                  onChange={handleChange}
                  setError={setError}
                  error={error}
                  label="Special Notes"
                  message={error.WPQ_specialNote.message}
                ></SingleInput>
              </Form.Group>
            </Col>
          </Row>
        </Row>
        <Row style={{ background: "white", padding: "20px 60px" }}>
          <Row className="mb-1">
            <Col md={12}>
              <p className="WPS-blue-text ">Base Metal (QW-403) </p>
              <BaseMetalTableTTS
                headerObj={headerObj}
                setheaderObj={setheaderObj}
                error={error}
                isReadonly={isReadonly}
                disableFields={disableFields}
                handleChange={handleChange}
                setError={setError}
                PNoActive={PNoActive}
                blyestyle={blyestyle}
                errorstyle={errorstyle}
                setIsEdited={setIsEdited}
                isAllowDashedSpecialCharacters={isAllowDashedSpecialCharacters}
              ></BaseMetalTableTTS>
            </Col>
            <Col md={6}>
              <Form.Group>
                <SingleInput
                  disabled={disableFields}
                  name="WPQ_BM_RangeQualified_Thk"
                  type="text"
                  maxLength={17}
                  readOnly={isReadonly}
                  status={error.WPQ_BM_RangeQualified_Thk.status}
                  value={headerObj?.WPQ_BM_RangeQualified_Thk}
                  onChange={handleChange}
                  setError={setError}
                  error={error}
                  label="Range Qualified Tube Thickness"
                  message={error.WPQ_BM_RangeQualified_Thk.message}
                  allowlistfunction={isAllowCustomSpecialCharacters}
                  allowcharacters="±+-="
                  customMessage="Special Characters # & % + $ ' < >  ; not allowed"
                ></SingleInput>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <SingleInput
                  disabled={disableFields}
                  name="WPQ_BM_RangeQualified_Dia"
                  type="text"
                  maxLength={17}
                  readOnly={isReadonly}
                  status={error.WPQ_BM_RangeQualified_Dia.status}
                  value={headerObj?.WPQ_BM_RangeQualified_Dia}
                  onChange={handleChange}
                  setError={setError}
                  error={error}
                  label="Range Qualified Tube Diameter"
                  message={error.WPQ_BM_RangeQualified_Dia.message}
                  allowlistfunction={isAllowCustomSpecialCharacters}
                  allowcharacters="±+-="
                  customMessage="Special Characters # & % + $ ' < >  ; not allowed"
                ></SingleInput>
              </Form.Group>
            </Col>
          </Row>
        </Row>
        <Row style={{ padding: "20px 60px" }} className="WPQ-Page-row-padding">
          <Row className="mb-1">
            <p className="WPS-blue-text">Joint Detail</p>
            <Col md={6}>
              <WpqJointDetailtable1A
                headerObj={headerObj}
                name={["WPQ_Hole_Id", "WPQ_Tube_Pitch", "WPQ_Groove_Depth"]}
                readOnly={isReadonly}
                maxLength={12}
                handleActualValueChange={handleActualValueChange}
                handleRangeQualifiedChange={handleRangeQualifiedChange}
                ColumnHeader={[
                  "Hole ID mm",
                  "Tube Pitch mm",
                  "Groove Depth mm",
                ]}
                error={error}
                setError={setError}
                isTubsheetRow={true}
                disableFields={disableFields}
              />
            </Col>
            <Col md={6}>
              <WpqJointDetailtable1A
                headerObj={headerObj}
                name={[
                  "WPQ_Tube_Projection",
                  "WPQ_Width_Ligament",
                  "WPQ_Pattern",
                  "WPQ_Groove_Angle",
                ]}
                maxLength={12}
                readOnly={isReadonly}
                handleActualValueChange={handleActualValueChange}
                handleRangeQualifiedChange={handleRangeQualifiedChange}
                ColumnHeader={[
                  "Tube Projection",
                  "Width of Ligament mm",
                  "Pattern",
                  "Groove Angle(°)/Radius mm",
                ]}
                error={error}
                setError={setError}
                isTubsheetRow={false}
                disableFields={disableFields}
              />
            </Col>
          </Row>
        </Row>
        <Row style={{ padding: "20px 60px" }}>
          <div className="row">
            <span className="WPS-blue-text col-md-4">
              Tube Hole Ligament Detail
            </span>
            <span className="WPS-blue-text col-md-4">Tube Hole Detail</span>
            <span className="WPS-blue-text col-md-4">
              {" "}
              Tube to Tubesheet Weld Joint Detail{" "}
            </span>
          </div>
          <ImageArray3
            handleFile={handleFile1}
            previewUrl1={previewUrl1}
            previewUrl2={previewUrl2}
            previewUrl3={previewUrl3}
            setPreviewUrl1={setPreviewUrl1}
            setPreviewUrl2={setPreviewUrl2}
            setPreviewUrl3={setPreviewUrl3}
            headerObj={headerObj}
            setheaderObj={setheaderObj}
            name="fileInput"
            name1="fileInput1"
            name2="fileInput2"
            name3="fileInput3"
            type="file"
            accept="image/*"
            fileInputRef={fileInputRef}
            readOnly={isReadonly}
            disableFields={disableFields}
          ></ImageArray3>
        </Row>
        <Row style={{ padding: "20px 47px" }}>
          <Col md={12}>
            <p className="WPS-blue-text">Filler Metals (QW-404)</p>
            <WPQ_Filler_metals
              detailObj={detailObj}
              disabled={disableFields}
              disableFields={disableFields}
              error={error}
              readOnly={isReadonly}
              handleChangedetailsarray={handleChangedetailsarray}
              setError={setError}
              setdetailObj={setdetailObj}
              SfaActive={SfaActive}
              AnoActive={AnoActive}
              FnoActive={FnoActive}
              classError={classError}
              setClassError={setClassError}
              chemicalAnaError={chemicalAnaError}
              setChemicalAnaError={setChemicalAnaError}
              setIsEdited={setIsEdited}
            ></WPQ_Filler_metals>
          </Col>
        </Row>
        <Row style={{ background: "white", padding: "0px 60px" }}>
          <Row className="mb-1">
            <Col md={3}>
              <Form.Group>
                <SingleInput
                  disabled={disableFields}
                  name="WPQ_FM_PreFillerMetal"
                  type="text"
                  maxLength={4}
                  readOnly={isReadonly}
                  status={error.WPQ_FM_PreFillerMetal.status}
                  value={headerObj?.WPQ_FM_PreFillerMetal}
                  onChange={handleChange}
                  setError={setError}
                  error={error}
                  label="Preplaced Filler Metal"
                  message={error.WPQ_FM_PreFillerMetal.message}
                ></SingleInput>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <SingleInput
                  disabled={disableFields}
                  name="WPQ_FM_WithFillerMetal"
                  type="text"
                  maxLength={7}
                  readOnly={isReadonly}
                  status={error.WPQ_FM_WithFillerMetal.status}
                  value={headerObj?.WPQ_FM_WithFillerMetal}
                  onChange={handleChange}
                  setError={setError}
                  error={error}
                  label="With/ Without Filler Metal"
                  message={error.WPQ_FM_WithFillerMetal.message}
                ></SingleInput>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <SingleInput
                  disabled={disableFields}
                  name="WPQ_FM_FillerProduct"
                  type="text"
                  maxLength={6}
                  readOnly={isReadonly}
                  status={error.WPQ_FM_FillerProduct.status}
                  value={headerObj?.WPQ_FM_FillerProduct}
                  onChange={handleChange}
                  setError={setError}
                  error={error}
                  label="Filler Metal Product Form"
                  message={error.WPQ_FM_FillerProduct.message}
                ></SingleInput>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <SingleInput
                  disabled={disableFields}
                  name="WPQ_FM_Inserts"
                  type="text"
                  maxLength={4}
                  readOnly={isReadonly}
                  status={error.WPQ_FM_Inserts.status}
                  value={headerObj?.WPQ_FM_Inserts}
                  onChange={handleChange}
                  label="Inserts"
                  message={error.WPQ_FM_Inserts.message}
                  setError={setError}
                  error={error}
                ></SingleInput>
              </Form.Group>
            </Col>
            <Col md={9}>
              <Form.Group>
                <SingleInput
                  disabled={disableFields}
                  name="WPQ_FM_FillerOthers"
                  type="text"
                  maxLength={60}
                  readOnly={isReadonly}
                  status={error.WPQ_FM_FillerOthers.status}
                  value={headerObj?.WPQ_FM_FillerOthers}
                  onChange={handleChange}
                  label="Filler Metals - Others"
                  message={error.WPQ_FM_FillerOthers.message}
                  setError={setError}
                  error={error}
                ></SingleInput>
              </Form.Group>
            </Col>
          </Row>
        </Row>
      </Row>
    );
  }
);

export default WPQTubesheetPage1;